// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"1b60c5a13425a7cba9dc","293":"6ae4f5ea2a7531c22ad1","522":"918391d98d6116df53c9","952":"6558f1508c119701cdfa"}[chunkId] + ".js";
};